import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  DateField,
  DateInput,
  required,
} from 'react-admin';

export const UpdateStateList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <DateField source="date" showTime />
    </Datagrid>
  </List>
);

export const UpdateStateEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="name" validate={required()} fullWidth />
      <DateInput source="date" />
    </SimpleForm>
  </Edit>
);

export const UpdateStateCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={required()} fullWidth />
      <DateInput source="date" />
    </SimpleForm>
  </Create>
);

export const UpdateStateShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <DateField source="date" showTime />
    </SimpleShowLayout>
  </Show>
);
